module.exports = __webpack_public_path__ + "assets/comp-5.d9f03315e3046455b6c7e0ca9f336ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/login/comp-5.jpg
// module id = CuBj
// module chunks = 0